/* global Swiper */
// @ts-ignore — Swiper loaded globally via CDN
/** @type {any} */
var Swiper;

// ================================
// Product Gallery Swiper
// Mobile-only free-drag swiper for .js-product-gallery elements.
// Initializes on mobile (<992px), destroys on desktop (CSS grid takes over).
// ================================

function initProductGallerySwipers() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.js-product-gallery:not([data-swiper-ready])').forEach((el) => {
    el.setAttribute('data-swiper-ready', '');

    /** @type {any} */
    let swiperInstance = null;
    const mq = window.matchMedia('(min-width: 992px)');

    /** @param {MediaQueryListEvent | MediaQueryList} e */
    function handleBreakpoint(e) {
      if (e.matches) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      } else {
        if (!swiperInstance) {
          // @ts-ignore — Swiper is loaded globally via CDN
          swiperInstance = new Swiper(el, {
            slidesPerView: 1,
            freeMode: true,
            grabCursor: true,
            speed: 600,
            scrollbar: {
              el: el.querySelector('.swiper-scrollbar'),
              draggable: true,
            },
          });
        }
      }
    }

    mq.addEventListener('change', handleBreakpoint);
    handleBreakpoint(mq);
  });
}

// ================================
// Product Main (fspm) — color variants, material dropdown, accordions
// ================================

function initProductMain() {
  const section = document.querySelector('.fspm');
  if (!section) return;
  const fspm = /** @type {Element} */ (section);

  // Color variant selection
  const colorBtns = fspm.querySelectorAll('[data-color-btn]');
  const variantIdInput = fspm.querySelector('[data-variant-id-input]');

  function updateGalleryEdgeClasses() {
    var slides = /** @type {HTMLElement[]} */ (Array.from(fspm.querySelectorAll('.fspm__gallery-slide')));
    var visible = slides.filter(function (s) { return !s.hidden; });
    slides.forEach(function (s) { s.classList.remove('is-first', 'is-last'); });
    var first = /** @type {HTMLElement | undefined} */ (visible[0]);
    var last = /** @type {HTMLElement | undefined} */ (visible[visible.length - 1]);
    if (first) first.classList.add('is-first');
    if (last) last.classList.add('is-last');
  }

  /** @param {string} variantId */
  function filterGallery(variantId) {
    var slides = /** @type {HTMLElement[]} */ (Array.from(fspm.querySelectorAll('.fspm__gallery-slide:not([data-fill])')));

    // Normal filter: show selected variant + general (no variant-id), hide others
    slides.forEach(function (slide) {
      var slideVariantId = slide.dataset.variantId;
      slide.hidden = Boolean(slideVariantId) && slideVariantId !== variantId;
    });

    // Reset all buffer slides to hidden
    /** @type {NodeListOf<HTMLElement>} */ (fspm.querySelectorAll('.fspm__gallery-slide[data-fill]')).forEach(function (s) {
      s.hidden = true;
    });

    // Fill to at least 2 using buffer slides
    var fillNeeded = 2 - slides.filter(function (s) { return !s.hidden; }).length;
    if (fillNeeded > 0) {
      // Variant position heuristic: first half → use last buffers; second half → use first buffers
      var variantIdx = slides.findIndex(function (s) { return s.dataset.variantId === variantId; });
      var isFirstHalf = variantIdx < 0 || variantIdx < slides.length / 2;
      var pools = isFirstHalf ? ['last', 'first'] : ['first', 'last'];

      pools.forEach(function (pool) {
        /** @type {NodeListOf<HTMLElement>} */ (fspm.querySelectorAll('.fspm__gallery-slide[data-fill="' + pool + '"]')).forEach(function (slide) {
          if (fillNeeded <= 0) return;
          slide.hidden = false;
          fillNeeded--;
        });
      });
    }

    updateGalleryEdgeClasses();
    var gallerySwiper = /** @type {any} */ (fspm.querySelector('.fspm__gallery-swiper'));
    if (gallerySwiper && gallerySwiper.swiper) {
      gallerySwiper.swiper.update();
    }
  }

  updateGalleryEdgeClasses();

  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      colorBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var hBtn = /** @type {HTMLElement} */ (btn);
      var hInput = /** @type {HTMLInputElement | null} */ (variantIdInput);
      if (hInput && hBtn.dataset.variantId) {
        hInput.value = hBtn.dataset.variantId;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', hBtn.dataset.variantId);
        history.replaceState({}, '', url.toString());
        filterGallery(hBtn.dataset.variantId);
      }
    });
  });

  // Material option dropdown
  const select = fspm.querySelector('[data-fspm-select]');
  if (select) {
    const btn = select.querySelector('[data-fspm-select-btn]');
    const menu = select.querySelector('[data-fspm-select-menu]');
    const labelEl = select.querySelector('[data-fspm-select-label]');

    if (btn && menu) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) menu.setAttribute('hidden', '');
        else menu.removeAttribute('hidden');
      });

      menu.querySelectorAll('[data-fspm-select-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var hOpt = /** @type {HTMLElement} */ (opt);
          if (labelEl) labelEl.textContent = hOpt.textContent.trim();
          var hSelect = /** @type {HTMLElement} */ (select);
          hSelect.dataset.selectedValue = hOpt.dataset.value || '';
          btn.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        });
      });

      var firstOption = /** @type {HTMLElement | null} */ (menu.querySelector('[data-fspm-select-option]'));
      if (firstOption) firstOption.click();

      document.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
      });
    }
  }

  // Accordions
  fspm.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const body = /** @type {HTMLElement | null} */ (accordion.querySelector('[data-accordion-body]'));
    if (!trigger || !body) return;

    body.removeAttribute('hidden');
    body.style.maxHeight = '0';
    body.style.overflow = 'hidden';

    trigger.addEventListener('click', function () {
      const isOpen = accordion.classList.contains('is-open');
      accordion.classList.toggle('is-open', !isOpen);
      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { body.style.maxHeight = '0'; });
        });
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.addEventListener('transitionend', function handler() {
          if (accordion.classList.contains('is-open')) body.style.maxHeight = 'none';
          body.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  // Open first accordion by default
  const firstAccordionTrigger = /** @type {HTMLElement | null} */ (fspm.querySelector('[data-accordion-trigger]'));
  if (firstAccordionTrigger) firstAccordionTrigger.click();

  // Color variants — show only first row, add "+X more" for overflow
  const colorsGrid = /** @type {HTMLElement | null} */ (fspm.querySelector('.fspm__colors-grid'));

  function setupColorRows() {
    if (!colorsGrid) return;
    if (colorsGrid.hasAttribute('data-colors-expanded')) return;

    // Remove existing "+more" button and restore hidden items
    var existingMore = colorsGrid.querySelector('.fspm__color-more');
    if (existingMore) existingMore.remove();
    var allItems = /** @type {HTMLElement[]} */ (Array.from(colorsGrid.querySelectorAll('.fspm__color-item')));
    allItems.forEach(function (item) { item.style.display = ''; });

    if (allItems.length === 0) {
      colorsGrid.setAttribute('data-colors-measured', '');
      return;
    }

    var firstItem = /** @type {HTMLElement} */ (allItems[0]);
    var firstTop = firstItem.getBoundingClientRect().top;
    var firstRowCount = allItems.filter(function (item) {
      return Math.abs(item.getBoundingClientRect().top - firstTop) < 5;
    }).length;

    colorsGrid.setAttribute('data-colors-measured', '');

    // Need overflow? Hide last first-row item to make room for the button
    var hiddenCount = allItems.length - firstRowCount;
    if (hiddenCount === 0) return;

    // Last item in row 1 gets replaced by the button; its count adds to hidden
    var lastVisible = /** @type {HTMLElement} */ (allItems[firstRowCount - 1]);
    lastVisible.style.display = 'none';
    var totalHidden = hiddenCount + 1;

    // Hide remaining rows
    allItems.slice(firstRowCount).forEach(function (item) { item.style.display = 'none'; });

    // Inject "+X more" before the last (now hidden) first-row item
    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'fspm__color-more';
    moreBtn.textContent = '+' + totalHidden + ' more';
    moreBtn.addEventListener('click', function () {
      colorsGrid.setAttribute('data-colors-expanded', '');
      allItems.forEach(function (item) { item.style.display = ''; });
      moreBtn.remove();
    });
    colorsGrid.insertBefore(moreBtn, lastVisible);
  }

  setupColorRows();

  if (typeof ResizeObserver !== 'undefined' && colorsGrid) {
    var ro = new ResizeObserver(setupColorRows);
    ro.observe(colorsGrid);
  }

  // ATC loading / success animation
  var atcBtn = /** @type {HTMLButtonElement | null} */ (fspm.querySelector('.fspm__atc'));
  var atcForm = fspm.querySelector('.fspm__form');
  var productFormEl = fspm.querySelector('product-form-component');

  if (atcBtn && atcForm && productFormEl) {
    var btn = /** @type {HTMLButtonElement} */ (atcBtn);
    var originalText = btn.textContent || '';

    atcForm.addEventListener('submit', function () {
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      btn.classList.add('is-loading');
    });

    productFormEl.addEventListener('cart:update', function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = '\u2713 Added';
      btn.classList.add('is-success');
      setTimeout(function () {
        btn.classList.remove('is-success');
        btn.textContent = originalText;
      }, 2000);

      var cartDrawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });

    productFormEl.addEventListener('cart:error', function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
    });
  }
}

// ================================
// Gallery zoom modal
// ================================

function initGalleryZoom() {
  var modal    = /** @type {HTMLElement | null} */ (document.getElementById('fspm-zoom-modal'));
  var zoomImg  = /** @type {HTMLImageElement | null} */ (document.querySelector('.fspm__zoom-img'));
  var closeBtn = /** @type {HTMLElement | null} */ (document.querySelector('.fspm__zoom-close'));
  var prevBtn  = /** @type {HTMLElement | null} */ (document.querySelector('.fspm__zoom-nav--prev'));
  var nextBtn  = /** @type {HTMLElement | null} */ (document.querySelector('.fspm__zoom-nav--next'));
  if (!modal || !zoomImg || !closeBtn || !prevBtn || !nextBtn) return;
  var zoomModal = /** @type {HTMLElement} */ (modal);
  var img = /** @type {HTMLImageElement} */ (zoomImg);

  var SWIPE_THRESHOLD = 50;

  /** @type {HTMLImageElement[]} */
  var images = [];
  var current = 0;

  /** @param {number} index */
  function showImage(index) {
    var total = images.length;
    if (!total) return;
    current = (index + total) % total;
    var source = images[current];
    if (!source) return;
    img.src = source.currentSrc || source.src;
    img.alt = source.alt || '';
  }

  /** @param {HTMLImageElement} clicked */
  function openZoom(clicked) {
    // Only the slides currently visible in the gallery (variant filtering hides others)
    images = /** @type {HTMLImageElement[]} */ (
      Array.from(document.querySelectorAll('.fspm__gallery-slide:not([hidden]) .fspm__gallery-img'))
    );
    var index = images.indexOf(clicked);
    if (index === -1) {
      images = [clicked];
      index = 0;
    }
    var single = images.length < 2;
    if (prevBtn) prevBtn.hidden = single;
    if (nextBtn) nextBtn.hidden = single;

    showImage(index);
    zoomModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeZoom() {
    zoomModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    img.src = '';
    img.style.transform = '';
  }

  // Click on any gallery slide image
  document.addEventListener('click', function (e) {
    var target = /** @type {HTMLElement} */ (e.target);
    var slide  = target.closest('.fspm__gallery-slide');
    if (!slide) return;
    var slideImg = /** @type {HTMLImageElement | null} */ (slide.querySelector('.fspm__gallery-img'));
    if (!slideImg) return;
    openZoom(slideImg);
  });

  prevBtn.addEventListener('click', function () { showImage(current - 1); });
  nextBtn.addEventListener('click', function () { showImage(current + 1); });

  // Swipe / drag (mouse + touch via pointer events)
  var startX = 0;
  var startY = 0;
  var deltaX = 0;
  var dragging = false;
  var suppressClick = false;

  zoomModal.addEventListener('pointerdown', function (e) {
    suppressClick = false;
    if (images.length < 2) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (/** @type {HTMLElement} */ (e.target).closest('button')) return;
    dragging = true;
    startX = e.clientX;
    startY = e.clientY;
    deltaX = 0;
  });

  zoomModal.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    deltaX = e.clientX - startX;
    // Let vertical gestures through (e.g. pinch / scroll on touch)
    if (!zoomModal.classList.contains('is-dragging')) {
      if (Math.abs(deltaX) < 5 || Math.abs(deltaX) < Math.abs(e.clientY - startY)) return;
      zoomModal.classList.add('is-dragging');
      zoomModal.setPointerCapture(e.pointerId);
    }
    img.style.transform = 'translateX(' + deltaX + 'px)';
  });

  /** @param {PointerEvent} e */
  function endDrag(e) {
    if (!dragging) return;
    dragging = false;
    var wasDragging = zoomModal.classList.contains('is-dragging');
    zoomModal.classList.remove('is-dragging');
    if (zoomModal.hasPointerCapture(e.pointerId)) zoomModal.releasePointerCapture(e.pointerId);
    img.style.transform = '';
    if (!wasDragging) return;

    // A drag shouldn't count as a backdrop click
    suppressClick = true;
    if (Math.abs(deltaX) >= SWIPE_THRESHOLD) {
      showImage(deltaX < 0 ? current + 1 : current - 1);
    }
  }

  zoomModal.addEventListener('pointerup', endDrag);
  zoomModal.addEventListener('pointercancel', endDrag);

  // Close on backdrop click (outside the image wrapper and nav buttons)
  zoomModal.addEventListener('click', function (e) {
    if (suppressClick) {
      suppressClick = false;
      return;
    }
    var target = /** @type {HTMLElement} */ (e.target);
    if (!target.closest('.fspm__zoom-inner, .fspm__zoom-nav')) closeZoom();
  });

  closeBtn.addEventListener('click', closeZoom);

  document.addEventListener('keydown', function (e) {
    if (zoomModal.hasAttribute('hidden')) return;
    if (e.key === 'Escape') closeZoom();
    else if (e.key === 'ArrowLeft' && images.length > 1) showImage(current - 1);
    else if (e.key === 'ArrowRight' && images.length > 1) showImage(current + 1);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGallerySwipers);
  document.addEventListener('DOMContentLoaded', initProductMain);
  document.addEventListener('DOMContentLoaded', initGalleryZoom);
} else if (typeof Swiper !== 'undefined') {
  initProductGallerySwipers();
  initProductMain();
  initGalleryZoom();
} else {
  window.addEventListener('load', initProductGallerySwipers, { once: true });
  window.addEventListener('load', initProductMain, { once: true });
  window.addEventListener('load', initGalleryZoom, { once: true });
}
